export default function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}